import * as XLSX from 'xlsx';

export type ParsedRow = {
	nationality: string;
	document: string;
	title: string;
	email: string;
};

const HEADER_ALIASES: Record<keyof ParsedRow, string[]> = {
	nationality: ['nacionalidade', 'nationality'],
	document: ['documento', 'document', 'cpf'],
	title: ['nome', 'nome do autor', 'title', 'titulo', 'título'],
	email: ['email', 'e-mail', 'mail'],
};

function findKey(row: Record<string, unknown>, aliases: string[]): string {
	const normalized = Object.keys(row).reduce<Record<string, string>>(
		(acc, key) => {
			acc[key.trim().toLowerCase()] = key;
			return acc;
		},
		{}
	);
	for (const alias of aliases) {
		if (alias in normalized) return normalized[alias];
	}
	return '';
}

export async function parseSheet(file: File): Promise<ParsedRow[]> {
	const buffer = await file.arrayBuffer();
	const workbook = XLSX.read(buffer, { type: 'array', cellDates: false });
	const firstSheet = workbook.SheetNames[0];
	if (!firstSheet) return [];
	const sheet = workbook.Sheets[firstSheet];
	const rows = XLSX.utils.sheet_to_json<Record<string, unknown>>(sheet, {
		defval: '',
		raw: false,
	});

	return rows
		.map<ParsedRow>((row) => {
			const nationalityKey = findKey(row, HEADER_ALIASES.nationality);
			const documentKey = findKey(row, HEADER_ALIASES.document);
			const titleKey = findKey(row, HEADER_ALIASES.title);
			const emailKey = findKey(row, HEADER_ALIASES.email);

			return {
				nationality: String(row[nationalityKey] ?? '').trim(),
				document: String(row[documentKey] ?? '').trim(),
				title: String(row[titleKey] ?? '').trim(),
				email: String(row[emailKey] ?? '').trim(),
			};
		})
		.filter(
			(row) =>
				row.nationality || row.document || row.title || row.email
		);
}
